<button [attr.data-comp]="'CategoriesItem'" class="item item-block categories-item" (click)="onClickItem()">
  <div class="item-inner categories-item__inner">
    <div class="input-wrapper categories-item__wrapper">
      <div class="label-md categories-item__left">
        @if (item.category_id !== -999) {
          <h2 class="ellipses-label">{{item.category_name}}</h2>
        }
        @if (item.category_id === -999) {
          <h2 class="ellipses-label ellipses-label-all">{{allAssetsLabel}}</h2>
        }
        <p class="categories-item__highlight">
          @if (item.unit_count_current_available !== null && item.unit_count_current_in_fleet !== null) {
            <span>{{ 'count_available' | translateLabel: [item.unit_count_current_available | number, item.unit_count_current_in_fleet | number] }}</span>
            }&nbsp;
            @if (selectedCustomerCount === 1 && item.customer_unit_count_current_rented !== null) {
              <span
                class="customer-text categories-item__customer-text--green"
              >{{ 'Customer_has_count' | translateLabel: [item.customer_unit_count_current_rented] }}</span>
            }
            @if (selectedCustomerCount > 1 && item.customer_unit_count_current_rented !== null) {
              <span
                class="customer-text categories-item__customer-text--green"
              >{{ 'Customers_have_count' | translateLabel: [item.customer_unit_count_current_rented] }}</span>
            }
          </p>
          @if (item.unit_count_reserved) {
            <p class="categories-item__highlight"><i>{{ item.unit_count_reserved }} {{ 'reserved' | translateLabel: [] }}</i></p>
          }
        </div>
        <div class="categories-item__right">
          <div class="progress-container-right">
            <app-progress-bar label="{{'Util' | translateLabel: [] }}" percent="{{item.physical_utilization_current}}" fillColor="{{getUtilFillColor()}}"></app-progress-bar>
            <app-progress-bar showDetailsIfZero="false" label="{{ 'Bench' | translateLabel: [] }}" percent="{{item.physical_utilization_bench}}" fillColor="aqua"></app-progress-bar>
          </div>
        </div>
        <app-item-arrow></app-item-arrow>
      </div>
      <div class="button-effect"></div>
    </div>
  </button>
